import { render, staticRenderFns } from "./Tabsol.vue?vue&type=template&id=d9bf84e4"
import script from "./Tabsol.vue?vue&type=script&lang=js"
export * from "./Tabsol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports